export default {
  GOOGLE_PLACES_APIKEY: process.env.REACT_APP_GOOGLE_PLACES_APIKEY,
  REFRESH_TOKEN_CLIENT_ID: process.env.REACT_APP_REFRESH_TOKEN_CLIENT_ID,
  REFRESH_TOKEN_SECRET_HASH: process.env.REACT_APP_REFRESH_TOKEN_SECRET_HASH,
};
